module.exports = __webpack_public_path__ + "static/media/Tischlaeufer_35x130.b4823700.png";